var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandshake(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_600_3132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7732 15.3863C28.0095 16.15 26.7365 16.15 25.9728 15.3863L17.219 6.6521L3.41279 20.4388L2.12029 19.205C-0.170957 16.9138 -0.170957 13.1929 2.12029 10.9017L10.4236 2.59835C12.7149 0.307102 16.4357 0.307102 18.727 2.59835L28.7732 12.625C29.537 13.3888 29.537 14.6225 28.7732 15.3863ZM30.144 11.2346C31.6715 12.7621 31.6715 15.2492 30.144 16.7767C27.657 19.2638 25.0328 17.2075 24.602 16.7767L17.2386 9.41335L6.33071 20.3213C5.56696 21.085 5.56696 22.3188 6.33071 23.0825C7.09446 23.8463 8.32821 23.8463 9.11154 23.0825L18.159 14.035L19.5495 15.4254L10.502 24.4729C9.73821 25.2367 9.73821 26.4704 10.502 27.2342C11.2657 27.9979 12.4995 27.9979 13.2828 27.2342L22.3303 18.1867L23.7207 19.5771L14.6732 28.6246C13.9095 29.3884 13.9095 30.6221 14.6732 31.3859C15.437 32.1496 16.6707 32.1496 17.4345 31.3859L26.482 22.3384L27.8724 23.7288L18.8249 32.7763C18.0611 33.54 18.0611 34.7738 18.8249 35.5375C19.5886 36.3013 20.8224 36.3013 21.5861 35.5375L37.8795 19.205C40.1707 16.9138 40.1707 13.1929 37.8795 10.9017L29.5761 2.59835C27.324 0.346269 23.6815 0.307102 21.3903 2.48085L30.144 11.2346Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_600_3132",
    x: 0.401855,
    y: 0.879395,
    width: 39.1958,
    height: 37.231,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_600_3132"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_600_3132",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake);
export default __webpack_public_path__ + "static/media/handshake.f2e9d84198c258e50fddafc08c61376d.svg";
export { ForwardRef as ReactComponent };